import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import featurePic from 'assets/images/featurePic.jpg';

const LeaderImage = () => (
	<Box
		component={'img'}
		src={featurePic}
		sx={{
			maxWidth: { xs: 250, sm: 280, md: 350, lg: 390 },
			ml: 2,
			mr: 2,
			mt: 'auto',
			mb: 'auto',
			height: 'auto',
			position: 'absolute',
			bottom: '5%',
			alignContent: 'center',
			right: 0,
			display: { xs: 'none', md: 'block' },
			borderRadius: '50%',
			boxShadow: 2
		}}
	/>
);

const SimLeaderQuote = () => {
	const theme = useTheme();

	return (
		<Box position={'relative'}>
			<Grid container marginTop={{ xs: '10vw', sm: '5vw', md: '0vw', lg: '0vw' }}>
				<Grid item xs={12} data-aos={'fade-up'}>
					<Box
						maxWidth={'80vw'}
						display={'flex'}
						justifyContent={'left'}
						alignItems={'flex-start'}
						alignContent={'flex-start'}>
						<Box
							component={'img'}
							boxShadow={5}
							src={featurePic}
							sx={{
								maxWidth: { xs: '30vw', sm: '30vw', md: '30vw', lg: '30vw' },
								ml: 2,
								mr: 2,
								mt: 'auto',
								mb: 'auto',
								height: 'auto',
								position: 'absolute',
								bottom: '0%',
								alignContent: 'center',
								right: 0,
								display: { xs: 'block', sm: 'block', md: 'none' },
								borderRadius: '50%',
								boxShadow: 2
							}}
						/>
					</Box>
				</Grid>
				<Grid item sm={12} md={6} data-aos={'fade-up'} marginLeft={2} marginRight={2}>
					<Box marginBottom={0} marginTop={{ xs: 4, sm: 4, md: 0, lg: 0 }}>
						<SimTypography
							variant='h4'
							color='text.primary'
							sx={{
								fontWeight: 700,
								color: '#222B45',
								textAlign: { sm: 'center', md: 'left' },
								fontStyle: 'italic'
							}}>
							"A child with special needs is undeniably the most innocent and the parents’ grit is
							impeccable. We care deeply about the little fighters, their parents and the communities we
							serve. It is personal to all of us at SimSouls."
						</SimTypography>
					</Box>
					<Box marginBottom={0}>
						<SimTypography
							variant='h5'
							component='p'
							color='text.primary'
							sx={{
								color: '#222B45',
								textAlign: { sm: 'center', md: 'right' }
							}}>
							Ansar Khan
						</SimTypography>
						<SimTypography
							component='p'
							color='text.primary'
							sx={{
								color: '#222B45',
								textAlign: { sm: 'center', md: 'right' }
							}}>
							<Box component={'span'} sx={{ color: theme.palette.primary.main }}>
								Parent
							</Box>{' '}
							& Founder
						</SimTypography>
					</Box>
				</Grid>
				<LeaderImage />
			</Grid>
		</Box>
	);
};

export default SimLeaderQuote;
